import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'

type MakeProjectAdminPayload = {
  userId: string
}

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const makeProjectAdminURL = (userId: string) => {
  return `site_users/${userId}/make_project_admin`
}

const subscribeToNewsletterURL = (userId: string) => {
  return `site_users/${userId}/subscribe`
}

const participantEndpoint = {
  makeProjectAdmin: (data: MakeProjectAdminPayload) => {
    const { userId } = data
    return axiosRequest().put(makeProjectAdminURL(userId))
  },
  subscribeToNewsletter: (data: MakeProjectAdminPayload) => {
    const { userId } = data
    return axiosRequest().put(subscribeToNewsletterURL(userId))
  },
}

const participantAPI = {
  makeProjectAdmin: (params: MakeProjectAdminPayload) =>
    apiWrapper({
      endPoint: participantEndpoint.makeProjectAdmin,
      params,
      errorFailureAction: handleStatus500,
    }),
  subscribeToNewsletters: (params: MakeProjectAdminPayload) =>
    apiWrapper({
      endPoint: participantEndpoint.subscribeToNewsletter,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default participantAPI
